export default function fromLignesXlsxToTab(lignesXlsx) {
  const lignes = lignesXlsx.filter(ligne => {
    return !!(ligne.ID);
  });
  if (lignes.length === 0) return lignes;
  return lignes
    .map(obj => {
      return { id: obj.ID, tarifAccess: obj['TARIF HT ACCESS_1'] ? obj['TARIF HT ACCESS_1'] : 0 };
    });
}
